import throttle from 'lodash-es/throttle';
import Swiper from 'swiper/swiper-bundle.min';
import 'swiper/swiper-bundle.min.css';
import './index.sass';

const initSliders = () => {
  if (window.innerWidth < 768) {
    new Swiper('.dialog-slider__container', {
      loop: false,
    });
  }

  $(window).on('resize', throttle( function() {
    if (window.innerWidth < 768) {
      new Swiper('.dialog-slider__container', {
        loop: false,
      });
    }
  },500))
}

export {
  initSliders
}


